import React from "react";

interface ActionButtonProps {
  id: string;
  rowIndex: number;
  onClick: () => void;
  icon: React.ReactNode;
}

const ActionButton: React.FC<ActionButtonProps> = ({ id, rowIndex, onClick, icon }) => (
  <button id={`${id}-btn-${rowIndex}`} onClick={onClick}>
    {icon}
  </button>
);

export default ActionButton;